import { useQuery } from '@tanstack/react-query';
import { searchProviders, ProviderSearchParams } from '../services/providerService';

export const useProviderSearch = (params: ProviderSearchParams) => {
  return useQuery({
    queryKey: ['providers', 'search', params],
    queryFn: () => searchProviders(params),
    enabled: !!(params.user_lat && params.user_lon),
  });
};
